module.exports = __webpack_public_path__ + "static/media/rocket.1c53eb67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layout/top-nav/rocket.svg
// module id = 566
// module chunks = 0